import { render, staticRenderFns } from "./assign-customer.vue?vue&type=template&id=69153104&scoped=true"
import script from "./assign-customer.vue?vue&type=script&lang=js"
export * from "./assign-customer.vue?vue&type=script&lang=js"
import style0 from "./assign-customer.vue?vue&type=style&index=0&id=69153104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69153104",
  null
  
)

export default component.exports